import * as Actions from '../../../../redux/actions'

import BookingForm from './BookingForm'
import { Carousel } from 'react-bootstrap'
import {
    Image,
} from 'react-bootstrap'
import React from 'react'
import { connect } from 'react-redux'
import { image_boxing } from '../RegExValidate'
import { useLocation } from 'react-router-dom';
import PlaceHolderImage from '../../../../assets/images/placeholderImage.jpeg';
import { TextField } from '@material-ui/core'
import AiChatBox from '../AiChatBox/AiChatBox'
import { environment } from '../../../../Environments/environment'

const BookingFormSliderContainer_ = ({ activeTab, homepageSliderImage, setBookingFormActiveTab, homepageGeneralInfo, logo_width, is_mobile, bodyClientWidth, app_menu_height }) => {
    const booking_options = ["muvGpt", "planNewTrip", "plan a trip", "hotel", "flight", "train", "bus"]
    const [imageIndex, setIndex] = React.useState(0);

    const handleSelect = (index, indicator) => {
        let newIndex = imageIndex + 1;

        if (newIndex > 4) {
            newIndex = 0;
        }

        setIndex(newIndex)
        setBookingFormActiveTab(booking_options[newIndex])
    }
    let topImageHeight = ""
    if (!isNaN(is_mobile)) {
        topImageHeight = is_mobile ? Math.ceil(bodyClientWidth / 1.8) : 1100
    }


    const location = useLocation()
    const isFlightsPage = location && location.pathname.includes("/flight");
    const isHotelPage = location && location.pathname.includes("/stay");
    const gptPage = location && location.pathname.includes("/muvgpt");

    React.useEffect(() => {
        setBookingFormActiveTab(isFlightsPage ? "flight" : (!environment.production || gptPage) ? "muvGpt" : "")  ///default first tab
    }, [])


    return (
        <div className="position-relative" style={{ top: -app_menu_height + "px" }} >
            <div className="background-img-row m-0 homeSlider"  >
                <div className="carousel" >
                    <Carousel indicators={false} interval={null} fade={true} onSelect={(index, indicator) => handleSelect(index, indicator)}>
                        {homepageSliderImage && homepageSliderImage.length > 0 && homepageSliderImage.map((item, idx) => {
                            const backImage = image_boxing(item, bodyClientWidth, topImageHeight);
                            return (
                                <Carousel.Item key={idx} >
                                    <div   >
                                        <img className="d-block w-100"
                                            src={backImage}
                                            alt="top carousel"
                                        />

                                        <div className="overlay"></div>
                                    </div>
                                </Carousel.Item>
                            )
                        }
                        )}
                    </Carousel>

                    <Carousel.Caption style={{ zIndex: "1" }}>
                        <div style={{ marginTop: is_mobile ? "40px" : "200px", marginBottom: "40px", marginLeft: is_mobile ? "0px" : "14px", marginRight: is_mobile ? "0px" : "14px" }}>
                            <div className="hidden_1366" style={{ font: "28px/40px Futura Hv BT", textAlign: "left", marginBottom: "15px" }} >{homepageGeneralInfo.generalInfo && homepageGeneralInfo.generalInfo.inspirationalText}</div>
                            <div className="hidden_1366" style={{ width: "60%", font: "36px/50px Futura Hv BT", textAlign: "left", marginBottom: "15px", letterSpacing: "0.5px", color: "var(--mainWhite)", }}>Make the world your oyster</div>
                            <div className="hidden_1366" style={{ width: "80%", font: "18px/20px Futura Lt BT", textAlign: "left", marginBottom: "0px", letterSpacing: "0.5px", color: "var(--mainWhite)", lineHeight: 1.5 }}>
                                Let AI plan for you the perfect dream trip tailored to your interests and tastes, copy popular itineraries or build your own.
                            </div>
                            <div className="hidden_1366" style={{ width: "80%", font: "18px/20px Futura Lt BT", textAlign: "left", marginBottom: "10px", letterSpacing: "0.5px", color: "var(--mainWhite)", lineHeight: 1.5 }}>
                                Generate a free AI-personalized itinerary, you can then customize it, share it and book it with the click of a button.
                            </div>

                            <BookingForm />

                        </div>
                    </Carousel.Caption>
                </div>
            </div>

        </div >
    )

}

const mapStateToProps = (state) => ({

    logo_width: state.Setting.appMenu.logo.width,
    bodyClientWidth: state.Setting.htmlBody.bodyClientWidth,
    lang: state.Setting.lang,
    app_menu_height: state.Setting.appMenu.app_menu_height,
    homepageSliderImage: state.Home.homepage_slider_image,
    homepageGeneralInfo: state.Home.homepage_general_info,
    is_mobile: state.Setting.is_mobile,
    activeTab: state.FormBank.BookingForm.activeTab,
})

const mapDispatchToProps = {

    setBookingFormActiveTab: Actions.setBookingFormActiveTab,
}

const BookingFormSliderContainer = connect(mapStateToProps, mapDispatchToProps)(BookingFormSliderContainer_)
export default BookingFormSliderContainer
